import React from 'react';

import { UiFilterSelect } from '../../ui/ui-filter-select';

import { FilterOnChangeHandler } from './applicant-filters';

import { sortAlphabetically, SORT_ORDER } from '../../util/sort-functions';

export const StatusChangeReasonFilter = ({
  changeReasons,
  className,
  value,
  onChange,
  disabled,
  placeholder,
  label,
}: {
  changeReasons: { [reason: string]: number[] };
  className?: string;
  value: string;
  onChange: FilterOnChangeHandler;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
}) => {
  const options = Object.keys(changeReasons)
    .filter((scr) => scr.toLowerCase() !== 'other')
    .map((scr) => ({ label: scr, value: scr }))
    .sort(sortAlphabetically((o: SelectOption<string>) => o.label, SORT_ORDER.ASC));
  // keep "other" at the bottom to mirror experience when selecting reasons - other is always displayed last
  options.push({ label: 'Other', value: 'Other' });

  return (
    <UiFilterSelect
      label={label || 'Status Reason'}
      value={value}
      onChange={onChange}
      options={options}
      className={className}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};
